import { ModalTypes, ModalDefaults, ActionConfigs, Sizes, Types, FieldTypes, Align, Backdrop, ActionSizes, Validators, Colors } from '../../Constants.js';

export function _initValidationListeners(modal) {
    const { $body } = modal.elements;
    const $ = window.jQuery;
    if (!$body) return;

    $body.on('input change', 'input, select, textarea', (e) => {
        const id = $(e.target).attr('id');
        if (id) modal.touchedFields.add(id);
        modal._checkFormValidity(true);
    });

    $body.on('blur', 'input, select, textarea', (e) => {
        const $field = $(e.target);
        const id = $field.attr('id');
        if (!id) return;
        
        modal.touchedFields.add(id);
        const allFields = modal._getAllFields();
        const field = allFields.find(f => f.id === id);
        if (field) {
            modal._validateField(field, true, $field.val());
            modal._checkFormValidity(true);
        }
    });
}

export function _validateField(modal, field, showUI = false, val = null) {
    const { $body } = modal.elements;
    
    if (val === null) {
        const $field = $body.find('#' + field.id);
        val = $field.val();
    }

    const V = Validators;
    let error = null;

    if (field.required && !V.required(val)) {
        error = field.validationMessage || `${field.label} is required.`;
    }
    
    if (!error && val) {
        if (field.numeric && !V.numeric(val)) {
            error = `${field.label} must contain only digits.`;
        }
        else if (field.alphanumeric && !V.alphanumeric(val)) {
            error = `${field.label} must be alphanumeric.`;
        }
        else if (field.type === 'email' || field.email) {
            if (!V.email(val)) error = `Please enter a valid email address.`;
        }
        else if (field.minLength && !V.minLength(val, field.minLength)) {
            error = `${field.label} must be at least ${field.minLength} characters.`;
        }
        else if (field.exactLength && !V.exactLength(val, field.exactLength)) {
            error = `${field.label} must be exactly ${field.exactLength} characters.`;
        }
        else if (field.lengths && !V.discreteLength(val, field.lengths)) {
            error = `${field.label} must be ${field.lengths.join(' or ')} characters.`;
        }
        else if ((field.min !== undefined || field.max !== undefined) && !V.range(val, field.min, field.max)) {
            if (field.min !== undefined && field.max !== undefined) error = `${field.label} must be between ${field.min} and ${field.max}.`;
            else if (field.min !== undefined) error = `${field.label} must be at least ${field.min}.`;
            else error = `${field.label} must be at most ${field.max}.`;
        }
        else if (field.pattern && !V.pattern(val, field.pattern)) {
            error = field.patternMessage || `Invalid format for ${field.label}.`;
        }
        else if (field.compareTo) {
            const $other = $body.find('#' + field.compareTo);
            if (val !== $other.val()) {
                error = field.compareMessage || `${field.label} does not match.`;
            }
        }
    }

    // validate() runs independently — after built-in rules, always, even on empty values.
    // This lets custom functions enforce their own presence check or cross-field logic.
    if (!error && typeof field.validate === 'function') {
        const result = field.validate(val, modal._getFormData());
        if (result !== true) {
            error = typeof result === 'string' ? result : `Invalid ${field.label}.`;
        }
    }

    if (showUI || modal.touchedFields.has(field.id)) {
        modal._updateFieldUI(field.id, error, val);
    }

    return error;
}

export function _updateFieldUI(modal, id, error, val = null) {
    const $field = modal.elements.$body.find('#' + id);
    
    if (error) {
        $field.addClass('gm-is-invalid').removeClass('gm-is-valid');
        $field.siblings('.gm-error-msg').text(error).addClass('gm-show');
    } else {
        $field.removeClass('gm-is-invalid');
        const currentVal = val !== null ? val : $field.val();
        if (currentVal) $field.addClass('gm-is-valid');
        $field.siblings('.gm-error-msg').removeClass('gm-show').text('');
    }
}

export function _checkFormValidity(modal, silent = true) {
    const fields = modal._getAllFields();
    if (!fields || fields.length === 0) return true;

    const { $body } = modal.elements;
    let isFormValid = true;
    
    fields.forEach(f => {
        if (f.type === 'heading' || f.type === 'hidden') return;
        
        const val = f.type === 'checkbox'
            ? $body.find('#' + f.id).is(':checked')
            : $body.find('#' + f.id).val();
        const error = modal._validateField(f, !silent, val);
        
        if (error) {
            const isRequiredOnEmpty = (val === '' || val === null || val === undefined || val === false);
            if (!isRequiredOnEmpty || modal.touchedFields.has(f.id)) {
                isFormValid = false;
            }
        }
    });

    const $submitBtn = modal.elements.$modal.find('.gm-btn-submit, .gm-btn-accept');
    $submitBtn.prop('disabled', !isFormValid);
    
    return isFormValid;
}

export function _validateForm(modal, $body, fields) {
    const allFields = modal._getAllFields(fields);
    const data = {};
    let isValid = true;
    
    allFields.forEach(f => { if (f.id) modal.touchedFields.add(f.id); });

    allFields.forEach(f => {
        if (f.type === 'heading' || f.type === 'columns') return;
        if (f.type === 'hidden') {
            if (f.id) data[f.id] = $body.find('#' + f.id).val();
            return;
        }
        
        let val;
        if (f.type === 'checkbox') {
            const $chk = $body.find('#' + f.id);
            const isChecked = $chk.is(':checked');
            val = f.value !== undefined ? (isChecked ? f.value : false) : isChecked;
        } else {
            val = $body.find('#' + f.id).val();
        }
        data[f.id] = val;
        
        const error = modal._validateField(f, true, val);
        if (error) isValid = false;
    });
    
    return { isValid, data };
}

